import { render, staticRenderFns } from "./LicenseKanbanCard.vue?vue&type=template&id=9d2fe172&scoped=true&"
import script from "./LicenseKanbanCard.vue?vue&type=script&lang=js&"
export * from "./LicenseKanbanCard.vue?vue&type=script&lang=js&"
import style0 from "./LicenseKanbanCard.vue?vue&type=style&index=0&id=9d2fe172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2fe172",
  null
  
)

export default component.exports